import { useEffect, useState } from "react";
import api from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const NONE = "__none__";

export const PianoSelect = ({ value, onChange, testId }) => {
  const [piani, setPiani] = useState([]);
  useEffect(() => {
    api.get("/admin/moduli-piani").then(({ data }) => setPiani((data.piani || []).map((p) => p.nome))).catch(() => setPiani([]));
  }, []);
  const opts = value && !piani.some((p) => p.toLowerCase() === value.toLowerCase()) ? [...piani, value] : piani;
  return (
    <Select value={value || NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)}>
      <SelectTrigger data-testid={testId} className="mt-1.5 bg-slate-900/60 border-slate-700">
        <SelectValue placeholder="Seleziona un piano" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE} data-testid={`${testId}-option-none`}>Nessun piano</SelectItem>
        {opts.map((p) => (
          <SelectItem key={p} value={p} data-testid={`${testId}-option-${p.toLowerCase().replace(/\s+/g, "-")}`}>{p}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
